import { Component, Input, OnInit } from '@angular/core';
import { FundingSourceTypes } from '@core/typings/budget.typing';
import { Award } from '@features/awards/typings/award.typing';
import { InKindService } from '@features/in-kind/in-kind.service';

@Component({
    selector: 'gc-award-pdf-page',
    templateUrl: './award-pdf-page.component.html',
    styleUrls: ['./award-pdf-page.component.scss'],
    standalone: false
})
export class AwardPdfPageComponent implements OnInit {
  @Input() awards: Award[];
  @Input() isArchived: boolean;
  @Input() isForApplicantPortal: boolean;

  cashAward: Award;
  inKindAward: Award;
  allItemsMap = this.inKindService.allItemsMap;

  constructor (
    private inKindService: InKindService
  ) { }

  ngOnInit () {
    if (this.awards?.length > 0) {
      this.awards.forEach((award) => {
        if (award.awardType === FundingSourceTypes.DOLLARS) {
          this.cashAward = award;
        } else {
          this.inKindAward = award;
        }
      });
    }
  }
}
